import { render, staticRenderFns } from "./CoverArrayInput.vue?vue&type=template&id=3dce9064&scoped=true"
import script from "./CoverArrayInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoverArrayInput.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CoverArrayInput.vue?vue&type=style&index=0&id=3dce9064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_lodash@4.17.21_prettier@2.8.8_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce9064",
  null
  
)

export default component.exports